<template>
	<div class="swimIndex">
		<back-to :title="title"></back-to>
		<section class="swimIndex_content">
			<!-- banner -->
			<van-swipe class="packageTour-banner-swiper" :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item, index) in data_ad_image_array" :key="index">
					<img v-lazy="item.Url" />
				</van-swipe-item>
			</van-swipe>
			<!-- 分类 -->
			<div class="swimIndex_content_class">
				<span v-for="(item,index) in destination_list[type]"
					:class="tabIndex == index?'content_class-active':''" @click="tabIndex = index,moreShow=false,onSearch()">{{item.name}}</span>
				<span :class="tabIndex == 5?'content_class-active':''"
					@click="tabIndex = 5,moreShow=!moreShow">更多</span>
			</div>
			<!-- 下拉框 -->
			<div class="swimIndex_content_pop" v-if="moreShow">
				<div class="swimIndex_content_pops">
					<span v-for="(item,index) in menu_destination_list" @click="stabIndex = index,moreShow=false,onSearch()">{{item.areaname}}</span>
				</div>
			</div>
			<!-- 列表 -->
			<List :tab_menu_array_index="1" ref="changList"></List>
		</section>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'swimIndex',
		components: {
			BackTo,
			List
		},
		data() {
			return {
				title:"",
				moreShow: false,
				tabIndex: 0,
				type: 1,
				data_ad_image_array: [],
				menu_destination_list: [],
				destination_list: {
					3: [{
							id: 0,
							name: "全部",
						}, {
							id: 2937,
							name: "巴厘岛",
						},
						{
							id: 4433,
							name: "马尔代夫",
						},
						{
							id: 4434,
							name: "斐济",
						}
					],
					2: [{
							id: 0,
							name: "全部",
						}, {
							id: 3260,
							name: "张家界",
						},
						{
							id: 3253,
							name: "长沙",
						},
						{
							id: 3362,
							name: "成都",
						},
						{
							id: 3064,
							name: "太原",
						},
					],
					1: [{
							id: 0,
							name: "全部",
						}, {
							id: 3087,
							name: "沈阳",
						},
						{
							id: 3088,
							name: "大连",
						},
						{
							id: 3101,
							name: "长春",
						},
						{
							id: 3110,
							name: "哈尔滨",
						},
					]
				}
			}
		},
		created() {
			this.type = this.$route.query.type
		},
		mounted() {
			this.getBanner()
			this.getMore()
			let specialarea = ""
			if (this.type == 1) {
				//星球少年
				specialarea = ",2,"
				this.title = "星球少年"
			} else if (this.type == 2) {
				//火车专列
				specialarea = ",3,"
				this.title = "火车专列"
			} else if (this.type == 3) {
				//海岛
				specialarea = ",4,"
				this.title = "海岛游"
			}
			this.$nextTick(() => {
				this.$refs.changList.specialarea = specialarea
				this.$refs.changList.page = 1
				this.$refs.changList.connect_ProductList()
			});
		},
		methods: {
			onSearch() {
				this.$nextTick(() => {
					window.scrollTo(0, 0)
					if(this.tabIndex < 5){
						this.$refs.changList.endCityId = Number(this.destination_list[this.type][this.tabIndex].id)
						this.$refs.changList.endCityName = this.destination_list[this.type][this.tabIndex].name
					}else{
						this.$refs.changList.endCityId = Number(this.menu_destination_list[this.stabIndex].areaid)
						this.$refs.changList.endCityName = this.menu_destination_list[this.stabIndex].areaname
					}
					this.$refs.changList.loading = false
					this.$refs.changList.finished = false
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			getBanner() {
				let id = ""
				if (this.type == 1) {
					//星球少年
					id = 6721
				} else if (this.type == 2) {
					//火车专列
					id = 6720
				} else if (this.type == 3) {
					//海岛
					id = 6850
				}
				this.$post(
					this.$apiWebsiteSweet + '/api/Applets_GNTeam', {
						id: id
					}
				).then(res => {
					this.data_ad_image_array = res.FreeBanners
				})
			},
			getMore() {
				let specialarea = ""
				if (this.type == 1) {
					//星球少年
					specialarea = ",2,"
				} else if (this.type == 2) {
					//火车专列
					specialarea = ",3,"
				} else if (this.type == 3) {
					//海岛
					specialarea = ",4,"
				}
				this.$_post(
					this.$connectHttpDayun + '/team/api/teamarea/list', {
						specialarea: specialarea
					}
				).then(res => {
					this.menu_destination_list = res.objects
				})
			}

		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.swimIndex_content_class {
		width: 100%;
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 24px;
		box-sizing: border-box;
		background-color: #fff;
	}

	.swimIndex_content_class span {
		height: 88px;
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 30px;
		color: #333;
	}

	.content_class-active {
		position: relative;
		font-size: 35px !important;
		font-weight: bold;
		color: #293243;
		z-index: 2;
	}

	.content_class-active::after {
		content: "";
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 20px;
		width: 71px;
		height: 15px;
		background: linear-gradient(90deg, #FFC98B 0%, #FF7303 100%);
		border-radius: 10px;
		z-index: -1;
	}

	.packageTour-banner-swiper,
	.packageTour-banner-swiper img {
		width: 100%;
		height: 379px;
	}

	.swimIndex_content_pop {
		width: 100%;
		height: 390px;
		background-color: #fff;
		box-sizing: border-box;
		padding: 10px 20px;
		overflow: scroll;
		animation-name: pop-menu-bg-open;
		animation-duration: 200ms;
		animation-timing-function: linear;
		position: absolute;
		top: 555px;
		z-index: 999;
		box-shadow: -10px 5px 10px #ccc;
	}

	@keyframes pop-menu-bg-open {
		from {
			height: 0px;
		}

		to {
			height: 390px;
		}
	}

	.swimIndex_content_pops {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
	}

	.swimIndex_content_pop span {
		width: 168px;
		height: 67px;
		background: #F6F6F6;
		border-radius: 6px;
		font-size: 28px;
		line-height: 67px;
		text-align: center;
		color: #333333;
		margin-top: 20px;
	}

	.swimIndex_content_pops span:last-child:nth-child(4n-1) {
		margin-right: 180.7px;
	}

	.swimIndex_content_pops span:last-child:nth-child(4n-2) {
		margin-right: 361.4px;
	}
</style>
